import * as React from 'react';
import { Link } from 'react-router-dom';

import { PAGE_TEXT } from './components';
import { SuccessPage } from '../../components/SuccessPage/SuccessPage';

export const SignupSuccessful: React.FunctionComponent = () => {
  return (
    <div style={{ padding: '4rem' }}>
      <SuccessPage
        icon="succeed"
        title={PAGE_TEXT.THANKS_SIGNUP}
        message={PAGE_TEXT.GLAD_TO_SEE}
        action={
          <Link
            to="/login"
            style={{
              fontSize: '1.25rem',
            }}
          >
            {PAGE_TEXT.LOGIN_NOW}
          </Link>
        }
      />
    </div>
  );
};
